import React from 'react';
import { useState,useEffect } from "react";
import Spinner from 'react-bootstrap/Spinner';
import api from '../api/viewmyresultapi';
import loginapi from '../api/login';
import { APISERVERURL } from '../APIServerURL';
import SelectedImages from './SelectedImages'

const PaymentDetails = ({submissionStatus,setPaymentError,setIsPaymentOk,selectedSemester,session,accessToken,setAccessToken,setRefreshFailed}) => {
  const [isAppLoaded,setIsAppLoaded]=useState(false);  

  const [images,setImages]=useState([]);
  
  const [transactionNo, setTransactionNo] = useState("");
  const [amount, setAmount] = useState("");


  const [imgName,setImgName]=useState('');
  const handleAddNew=async (e)=>
      {
         e.preventDefault();
         
         
          let formData = new FormData();    //formdata object
          formData.append("transactionNo", transactionNo);
          formData.append("amount", amount);
          formData.append("selectedSemester", selectedSemester);
          formData.append("session", session);
    
          
    
          Object.values(images).forEach(file=>{
            formData.append("images", file);
          });
          const config = {     
              headers: { 'content-type': 'multipart/form-data' }
          }
    
        
         //call api to save the form  

         
          try{
          const response= await api.post('/updateTransaction',formData,{headers:{'Authorization':`Bearer ${accessToken}`}});      
          setRegistrationForm(response.data.registrationForm);
          setImages([]);
          }
          catch(err)
          {
              try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              //alert(JSON.stringify(x['data']['accessToken']));
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              //console.log(`ne at ${nat}`);
              //console.log(`Second at:${accessToken}`);
              try{       
                  const response= await api.post('/updateTransaction',formData,{headers:{'Authorization':`Bearer ${nat}`}});      
                  setRegistrationForm(response.data.registrationForm);  setImages([]);
              }
              catch(err)
              {
                  alert('unusual error newposts.js');
                 
                  //navigate('/');
              }
              }
              catch(err)
              {
              alert('failed');
             
              //setError(JSON.stringify(err));
              //navigate('/');
              }

          }
        }

  function addToImageList(selectedFiles)
  {
      const newImages=[...images,...selectedFiles];
      setImages(newImages);
      console.log(newImages.length);
  }

  useEffect( ()=>{
    loadAllSelectedCourses();
  },[selectedSemester]);
  
  
 
  const loadAllSelectedCourses=async ()=>{
      //alert(JSON.stringify(loggedInStudent)+" selected sem "+selectedSemester);
       try{       
         //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
         const response=await api.post('/getPaymentDetails',{session:session,semester:selectedSemester},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
         setRegistrationForm(response.data.registrationForm);
         }
         catch(err)
         {
           try{
             const config = { withCredentials: true };
             const x=await loginapi.get('/getAccessToken',config);            
             const nat=x['data']['accessToken'];
             const ufn=x['data']['userFullName'];
             const un=x['data']['userName'];
             const lt=x['data']['loginType'];
             //alert(nat);
             setAccessToken(nat);
             setRefreshFailed(false);  
                     
            
               if(lt.toLowerCase()==="student")
                 {
                       try{       
                         //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                         const response=await api.post('/getPaymentDetails',{session:session,semester:selectedSemester},{headers:{'Authorization':`Bearer ${nat}`}});                            
                         setRegistrationForm(response.data.registrationForm);
                     }
                     catch(err)
                     {
                       alert('refresh failed unusual'+ "line 50");
                       setAccessToken('');
                       setRefreshFailed(true);  
                     }
                   }
             }
             catch(err)
             {
               //alert('dd');
               setAccessToken(''); 
               setRefreshFailed(true);              
             }
         }         
          finally
             {
               setIsAppLoaded(true);
               //alert('app loaded'+accessToken);
             }
    }
    
    const setRegistrationForm = (form) => {
      setTransactionNo(form.transaction_no || "");
      setAmount(form.amount ||"");
      setImgName(form.images && form.images.length > 0 ? form.images[0] : '');
      if(form.transaction_no&&form.amount&&form.images&&form.images.length>0)
      {
        setIsPaymentOk(true);
       setPaymentError([]);
      }
      else{
        setIsPaymentOk(false);
        let pe=[];
      if(!form.transaction_no)
        {
          pe.push('Transaction Number Required!');
        }
        if(!form.amount)
          {
            pe.push('Amount Required!');
          }
          if(!form.images || form.images.length<=0)
            {
              pe.push('Transaction Image Required!');
            }
        setPaymentError(pe);
      }

      
    };

    
  
  return (
    <div className="formfillupview verticaldiv centrediv width1000 roundeddiv mt-4 mb-4">
      <p className='mt-3 p-1'>Your payment details For Semester {selectedSemester}</p>
      <div className='w-full flex flex-col justify-center items-center'>

      <form className='w-[98%] max-w-[600px] ' onSubmit={handleAddNew}>
      <div className="mt-4">
  <label>Transaction No</label>
  <input
    type="text"
    value={transactionNo}
    onChange={(e) => setTransactionNo(e.target.value)}
    className={`border-b-2 border-blue-500 p-2 w-full bg-transparent`}
  />
</div>

<div className="mt-4">
  <label>Amount</label>
  <input
    type="number"
     
    value={amount}
    onChange={(e) => setAmount(e.target.value)}
    onWheel={(e) => e.target.blur()}
    className={`border-b-2 border-blue-500 p-2 w-full bg-transparent`}
  />
</div>


<div className='w-full mt-6 mb-2 p-1'>
  <p>Uploaded Image:</p>
 {imgName && imgName!='' &&(<div className="block w-full h-[300px] overflow-hidden mt-4">
    <img
      src={`${APISERVERURL}/img/${imgName}`}
      alt="placeholder"
      className="w-65 h-full object-contain transform hover:scale-110 transition-transform duration-500"
    />
  </div>)}

  {!imgName  &&(<div className="block w-full h-[300px] overflow-hidden mt-4">
    <img
      src={`${APISERVERURL}/img/default.png`}
      alt="placeholder"
      className="w-65 h-full object-contain transform hover:scale-110 transition-transform duration-500"
    />
  </div>)}

</div>
            
            
            {submissionStatus.toUpperCase()!=='SUBMITTED' &&(<>
            <input className="marginTop" type='file' id="fuPhotos" name="uploadedPhotos" multiple
            accept="image/png, image/jpg, image/jpeg"
            onChange={(e)=>{addToImageList(e.target.files)}}
            ></input>
            <SelectedImages
            images={images}
            setImages={setImages}
            >
            </SelectedImages>
            <div className="flex justify-center mt-6 mb-6">
           
            <button
                type="submit"
                className="bg-blue-600 hover:bg-blue-800 text-white font-semibold  rounded-lg shadow-md transition text-xs p-3"
            >
                SAVE PAYMENT DETAILS
            </button>
            </div></>
)}
            

            

            </form>
      </div>
      
    </div>
  );
};

export default PaymentDetails;
